import { formatNumberUS } from '@ppwr/poker'

export type PlayerStats =
  | {
      numberOfHands?: number
      numberOfHandsWon?: number
      totalChipsWon?: number
      totalChipsLost?: number
      userStats?: {
        rank?: number | null
      }
    }
  | null
  | undefined

type PlayerStatsParams = {
  numberOfHands?: number
  numberOfHandsWon?: number
  totalChipsWon?: number
  totalChipsLost?: number
  rank?: number | null
}

/**
 * Generate stats lines for leave game message
 * @param params - Player stats parameters
 * @returns Array of formatted stats lines
 */
export const getLeaveGameStatsLines = (params: PlayerStatsParams): string[] => {
  const handsPlayed = params.numberOfHands ?? 0
  const handsWon = params.numberOfHandsWon ?? 0
  const totalChipsWon = params.totalChipsWon ?? 0
  const totalChipsLost = params.totalChipsLost ?? 0
  const chipsNet = totalChipsWon - totalChipsLost
  const rank = params.rank ?? null

  const chipsNetLabel = `${chipsNet >= 0 ? '+' : '-'}${formatNumberUS(Math.abs(chipsNet))}`

  return [
    `HANDS PLAYED: ${formatNumberUS(handsPlayed)}`,
    `HANDS WON: ${formatNumberUS(handsWon)}`,
    // TODO Hiding for now. Values are incorrect, double counting winners' chips in win-by-fold - PK
    // `CHIPS WON/LOSS TOTAL: ${chipsNetLabel}`,
    `LEADERBOARD POSITION: ${rank ? `#${rank}` : '-'}`
  ]
}
